import { TextFieldProps } from "@material-ui/core";

export const MuiTextField: TextFieldProps = {
  fullWidth: true,
  size: "small" as const,
  variant: "outlined" as const,
};
